import * as THREE from 'three';

export class ModelMaker {
    thickness = 1.5; // 厚度
    scale = 0.7; // 像素到毫米的转换比例

    constructor() {}

    init(scene) {
        this.group = new THREE.Group();
        let geom = new THREE.BufferGeometry();
        geom.setAttribute("position", new THREE.BufferAttribute(new Float32Array(), 3));
        // let material = new THREE.MeshNormalMaterial({
        let material = new THREE.MeshPhongMaterial({
        // let material = new THREE.MeshLambertMaterial({
            // wireframe: true,
            flatShading: true,
        });
        this.mesh = new THREE.Mesh(geom, material);
        // this.mesh.rotation.x = Math.PI * 0.5;
        this.mesh.position.z = -this.thickness * 0.5;
        this.group.add(this.mesh);

        this.mesh2 = new THREE.Mesh(geom, material);
        this.mesh2.rotation.y = Math.PI * 0.5;
        this.mesh2.position.x = -this.thickness * 0.5;
        this.group.add(this.mesh2);

        scene.add(this.group);
    }

    updateGeometry(vertices) {
        this.mesh.geometry.attributes.position = new THREE.BufferAttribute(new Float32Array(vertices), 3);
    }

    addBounds(vertices, ps, z1, z2) {
        // 内壁
        for (let i = 0, last = ps[ps.length - 1]; i < ps.length; i++) {
            let curr = ps[i];
            vertices.push(last.x, last.y, z1, curr.x, curr.y, z2, curr.x, curr.y, z1);
            vertices.push(last.x, last.y, z1, last.x, last.y, z2, curr.x, curr.y, z2);
            last = curr;
        }
    }

    makeModel(pathList) {
        let vertices = [];
        let s = this.scale;
        let z = this.thickness;
        pathList.forEach(path => {
            const faces = THREE.ShapeUtils.triangulateShape(path.shape, path.holes);
            let points = [...path.shape];
            path.holes.forEach(hole => { points.push(...hole); });
            points.forEach(p => { p.x *= s; p.y *= s; });
            faces.forEach(f => {
                let p1 = points[f[0]];
                let p2 = points[f[1]];
                let p3 = points[f[2]];
                vertices.push(p1.x, p1.y, 0);
                vertices.push(p3.x, p3.y, 0);
                vertices.push(p2.x, p2.y, 0);
                vertices.push(p1.x, p1.y, z);
                vertices.push(p2.x, p2.y, z);
                vertices.push(p3.x, p3.y, z);
            });
            this.addBounds(vertices, path.shape, z, 0);
            path.holes.forEach(hole => { this.addBounds(vertices, hole, z, 0); });
        });

        this.updateGeometry(vertices);
    }
}



// WEBPACK FOOTER //
// ./src/views/jewelryPendant/scripts/ModelMaker.js